module.exports = function() {
  return new Worker(__webpack_public_path__ + "e3bf3183e7064095d7c3.worker.js");
};